<app-navbar [title]="title">
	<a routerLink="./add" class="btn btn-primary me-3"> <i class="fas fa-plus"></i> Dodaj </a>
	<a class="btn btn-danger" routerLink="../"> <i class="fas fa-chevron-left"></i> Powrót </a>
</app-navbar>
<app-dynamic-table module="codebook/product_convenience" [elements]="data" [tableRows]="tableRows"> </app-dynamic-table>
